import React from 'react'
import { Link } from 'react-router-dom'

import { Pane } from '_components'

export const Help: React.FC = () => <Pane>
    <h1>Installation of a Sol tag</h1>
    <p>Compatible devices: iPhone 7 or newer, most Android devices.</p>

    Installation only takes a few simple steps.
    <ol>
        <li>Verify the tag is working by scanning it with your phone.</li>
        <li>Stick the tag onto your fretboard directly underneath the 5th fret marker.</li>
    </ol>

    Optional steps to follow for added reliability are:
    <ul>
        <li>Route a thin cavity for the tag. Recommended dimensions: 32mm diameter, 1mm depth.</li>
        <li>Further secure the tag with a piece of paper and a layer of glue.</li>
    </ul>

    <h1>Provisioning a Sol tag</h1>
    <ol>
        <li>Scan the tag with your phone and take note of the displayed model.</li>
        <li>Find it in the <Link to="/browse">instrument list</Link> and click "Edit".</li>
        <li>Finally, click "Save". The new information should be visible shortly.</li>
    </ol>
    <hr />
    <small> 
        <p><strong>Privacy policy</strong></p>
        <p>
            Instruments' descriptions, photos etc. are publicly available.
            You can edit this information using Atelier or request for changes to be made via e-mail.
        </p>
        <p>
            We may keep records of your name, e-mail address, postal address, telephone number, and other information relevant to the fulfillment of orders.
            We do not share this information with third parties.
        </p>
        <p>Should you wish to view, change, or withdraw any of your data, you are free to do so &mdash; please let us know.</p>
        <p><strong>Legal notice</strong></p>
        <p>Copyright&nbsp;&copy;&nbsp;{new Date().getFullYear()}&nbsp;Celerity&nbsp;Audio&nbsp;Ltd.</p>
        <p>Celerity&nbsp;Audio&nbsp;Ltd is a private&nbsp;limited&nbsp;company registered in&nbsp;England. Company&nbsp;no.:&nbsp;11146556. VAT&nbsp;no.:&nbsp;GB&nbsp;295&nbsp;1511&nbsp;00.</p>
        <p>Registered&nbsp;address: DNS&nbsp;House, 382&nbsp;Kenton&nbsp;Road, Harrow, HA3&nbsp;8DP, Middlesex, United&nbsp;Kingdom.</p>
    </small>
</Pane>
